const state = {
    head: {
        title: '热门电视剧',
        link: "https://video.contentchina.com/index"
    },
    carouselData: [
        {
            link: 'https://video.contentchina.com/index',
            imgUrl: require('@/assets/images/TV/TV1.png'),
        },

    ],
}

const mutations = {
    setCarouselData(state, list) {
        state.carouselData = list
    }
}

const actions = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}